import { AppState } from '@api-ui-app/src/app/app.state';
import {
  DesignPriceBreakdownItem,
  PriceBreakdown,
  PriceBreakdownPrintAreaNameEnum,
} from '@api-ui-app/src/app/shared/price-breakdown/types/price-breakdown';
import { PrintAreaName } from '@gelato-api-ui/core/print-areas/constants/print-area-name';
import { createSelector } from '@ngrx/store';
import { State } from './price-breakdown.reducer';

export const getState = (state: AppState): State => state.priceBreakdown;

export const getIsLoading = createSelector(getState, (state: State): boolean => state.isLoading);

export const getTotalPrice = createSelector(getState, (state: State): string => state.total);

export const getTotalProductPrice = createSelector(getState, (state: State): string => state.productTotal);

export const getIncludedPrintArea = createSelector(getState, (state: State): PrintAreaName => state.includedPrintArea);

export const getTotalDesignPrice = createSelector(getState, (state: State): string => state.designTotal);

export const getProductBasePrice = createSelector(
  getState,
  (state: State): string => state.breakdown?.[PriceBreakdownPrintAreaNameEnum.Product],
);

export const getPriceBreakdown = createSelector(getState, (state: State): PriceBreakdown => state.breakdown);

export const getIsPriceBreakdownError = createSelector(getState, (state: State): boolean => Boolean(state.error));

export const getDesignPriceBreakdown = createSelector(
  getState,
  (state: State): DesignPriceBreakdownItem[] => state.designBreakdown,
);
